import { render, staticRenderFns } from "./HolidaysPage.vue?vue&type=template&id=644b593b&scoped=true&"
import script from "./HolidaysPage.vue?vue&type=script&lang=js&"
export * from "./HolidaysPage.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysPage.vue?vue&type=style&index=0&id=644b593b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644b593b",
  null
  
)

export default component.exports